import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class AssetChart extends Component {
  constructor(props) {
    super(props);
    console.log("props in asset", props);
    const colors = ["#2796FD"];

    this.state = {
      //   series: [
      //     {
      //       name: "Assets",
      //       data: [351, 11, 11, 0],
      //     },
      //   ],
      series: this.props.assetSeries,
      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          //   categories: ["Cust 9", "Cust 1", "Cust 8", "Cust 2"],
          categories: this.props.assetCategories,
          title: {
            text: "Customer", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        yaxis: {
          title: {
            text: "Assets", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
          // Use logarithmic scale
          logarithmic: true,
          min: 1, // Start from 1 since log scale does not support 0
          tickAmount: 5, // Control the number of ticks on the Y-axis
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 500,
          },
          background: {
            enabled: true,
            foreColor: "#656161",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#656161",
          },
          offsetY: -20,
        },
        legend: {
          show: false,
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "70%",
            distributed: true,
            borderRadius: 5,
            dataLabels: {
              position: "top",
            },
          },
        },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.assetSeries !== this.props.assetSeries) {
      this.setState({ series: this.props.assetSeries });
    }
    if (prevProps.assetCategories !== this.props.assetCategories) {
      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: this.props.assetCategories,
          },
        },
      });
    }
  }

  render() {
    return (
      <div>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={200}
        />
      </div>
    );
  }
}
